import React from "react";

const LegalInformation = () => {
  return (
    <div
      style={{
        height: "100vh",
        margin: 20,
      }}
    >
      <h1
        style={{
          justifySelf: "center",
          alignContent: "center",
          marginBottom: 10,
        }}
      >
        Legal Disclaimer
      </h1>
      <p style={styles.paragraph}>
        This website participates in affiliate marketing programs, which means
        that when you purchase products through the links provided on our
        website, we may earn a commission at no additional cost to you. These
        commissions help support the maintenance and operation of our site. We
        strive to recommend products and services that we believe offer value to
        our users. However, we encourage you to perform your own research and
        make informed decisions before making any purchase. The commissions
        earned do not influence the content, topics, or products we feature. All
        opinions expressed are our own, and we aim to provide honest and
        accurate information. If you have any questions or concerns about our
        affiliate partnerships, feel free to contact us through our website's
        contact page. Thank you for supporting our website!
      </p>
      <br />
      <p style={styles.paragraph}>
        The prices displayed on our website are based on the item's price at the
        time of listing and may not reflect current pricing. For the most
        up-to-date price, please refer to the link provided.
      </p>
    </div>
  );
};

export default LegalInformation;

const styles = {
  paragraph: {
    justifySelf: "left",
    alignContent: "center",
    fontSize: "18px",
  },
};
